// @greenlight-spec: 20-agent-plugins.md
// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 06-agent-interface.md

/** Claude allows 3,000 characters of organization instructions. */
export const CLAUDE_ORG_INSTRUCTIONS_MAX_CHARS = 3000;

/** The Agent setup page on the control plane that serves this MCP URL. */
export function agentSetupUrl(mcpUrl: string): string {
  return `${mcpUrl.replace(/\/+$/, '').replace(/\/mcp$/, '')}/settings/agent-setup`;
}

/**
 * Always-on org instructions telling an agent what Greenlight is and when to
 * reach for it. A pointer to the Skill, never a copy of it.
 */
export function buildOrgInstructions(mcpUrl: string): string {
  return `Greenlight is this organization's governed platform for internal apps. It owns each app's source control, deployment, access to company data and systems, and audit trail.

Use Greenlight when the user:
- asks to build, change, deploy, share, or fix an internal app, dashboard, or tool — even if they don't say "Greenlight"
- is working in a repository that contains a greenlight.yml file
- needs company data or systems inside an app

How to use it:
- Use the Greenlight plugin: its greenlight Skill, its Greenlight MCP tools, and its greenlight CLI.
- Read the greenlight Skill in full before acting, and read it again after your context is compacted.
- If the plugin is not installed, tell the user and point them to ${agentSetupUrl(mcpUrl)}. The Greenlight MCP server is ${mcpUrl}.

Do not:
- create cloud resources, databases, or hosting outside Greenlight
- use gh or the GitHub web UI to open or merge pull requests in Greenlight app repositories — Greenlight does that
- ask for, invent, or hardcode credentials — Greenlight issues references to them`;
}
